import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { AdminHeader } from "./header/AdminHeader";
export const AdminLayout = () => {
    const [isSearchExpanded, setIsSearchExpanded] = useState(false);
    const toggleSearch = useCallback(() => {
        setIsSearchExpanded((prev) => !prev);
    }, []);
    // Collapse search if screen size goes above 1200px
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 1201 && isSearchExpanded) {
                setIsSearchExpanded(false);
            }
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [isSearchExpanded]);
    return (_jsx(Box, { sx: {
            backgroundImage: `url('/assets/images/background.png')`,
            backgroundSize: "cover",
            backgroundPosition: "top 10%",
            backgroundRepeat: "no-repeat",
            backgroundAttachment: "fixed",
            height: "100dvh",
            width: "100svw",
            backgroundColor: "#F4FBFF",
        }, children: _jsxs(Box, { sx: {
                pt: { xs: 8.25, sm: 8.75, md: 10.2 },
                pb: { xs: 0, sm: 0, md: 2 },
                width: "100%",
                px: { xs: 1, sm: 1, md: 1 },
                position: "relative",
                transition: "padding-left .2s ease-in-out",
            }, children: [_jsx(AdminHeader, { isSearchExpanded: isSearchExpanded, toggleSearch: toggleSearch }), _jsx("main", { children: _jsx(Outlet, {}) })] }) }));
};
